import { createContext, FC, useContext } from 'react';

import useTrackingData from './useTrackingData';


export const AnalyticsContext = createContext<ReturnType<typeof useTrackingData> | null>(null);

export const AnalyticsProvider: FC = ({ children }) => {
  const trackingData = useTrackingData();

  return (
    <AnalyticsContext.Provider value={trackingData}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);

  if (context === null) {
    throw new Error("useAnalytics must be used within a AnalyticsProvider");
  }

  return context;
};